import { takeLatest, put, select } from 'redux-saga/effects';
import { closePostAcqTasks, openPostAcqTasks, setPostAcqWorkflowLoadingOverlayState, appNotify } from 'store/actions';
import { postWithToken } from 'api/network';
import { userSelector } from 'store/selectors';

export function* postAcqTaskStatusSaga() {
  yield takeLatest(closePostAcqTasks, function* ({ payload: taskIds }) {
    try {
      const user = yield select(userSelector);
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Updating...' }));
      const res = yield postWithToken(`/api/postAcquisition/tasks/close?requestUserId=${user.id}`, taskIds);
      const closedTaskRes = yield res.json();

      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      if (closedTaskRes.data) {
        yield put(appNotify(`Closed ${closedTaskRes.data.length > 1 ? `${closedTaskRes.data.length} tasks` : 'task'}`, 'success'));
      } else if (closedTaskRes.error) {
        yield put(appNotify(closedTaskRes.error.message, 'error'));
      }
    } catch (error) {
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });

  yield takeLatest(openPostAcqTasks, function* ({ payload: taskIds }) {
    try {
      const user = yield select(userSelector);
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Updating...' }));
      const res = yield postWithToken(`/api/postAcquisition/tasks/open?requestUserId=${user.id}`, taskIds);
      const openedTaskRes = yield res.json();

      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      if (openedTaskRes.data) {
        yield put(appNotify(`Reopened ${openedTaskRes.data.length > 1 ? `${openedTaskRes.data.length} tasks` : 'task'}`, 'success'));
      } else if (openedTaskRes.error) {
        yield put(appNotify(openedTaskRes.error.message, 'error'));
      }
      
    } catch (error) {
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}
